(() => {
  const chart = 'https://pawsfrvr.com/cdn/shop/files/download_36.png?v=1774970455&width=1000';
  function setup() {
    document.querySelectorAll('select[name="properties[Font]"], select[aria-label="Font"]').forEach(select => {
      if (select.dataset.fontPreview || !Array.from(select.options).some(o => o.value === 'Font 8')) return;
      select.dataset.fontPreview = 'true';
      const box = document.createElement('div');
      box.className = 'paws-font-sample';
      const label = document.createElement('p');
      label.setAttribute('aria-live', 'polite');
      const crop = document.createElement('div');
      crop.className = 'paws-font-sample__crop';
      const image = document.createElement('img');
      image.src = chart; image.width = 1000; image.height = 750; image.loading = 'lazy';
      crop.append(image);
      const note = document.createElement('p');
      note.className = 'paws-font-sample__note';
      const details = document.createElement('details');
      const summary = document.createElement('summary'); summary.textContent = 'Compare all 8 fonts';
      const full = document.createElement('img'); full.src = chart; full.width = 1000; full.height = 750;
      full.alt = 'Eight actual lettering styles numbered 1 to 8. Font 2 uses uppercase letters only.'; full.loading = 'lazy';
      const fullLink = document.createElement('a'); fullLink.href = chart; fullLink.target = '_blank'; fullLink.rel = 'noopener';
      fullLink.textContent = 'Open full-size font chart';
      details.append(summary, full, fullLink); box.append(label, crop, note, details);
      select.closest('.select') ? select.closest('.select').after(box) : select.after(box);
      function update() {
        const number = Number(select.value.replace(/\D/g,''));
        const top = [143, 140, 302, 302, 477, 475, 646, 645][number - 1];
        const left = number % 2 ? 10 : 510;
        crop.style.aspectRatio = `480 / ${[104,112,112,118,105,108,90,96][number - 1]}`;
        image.style.transform = `translate(${-left / 10}%, ${-top / 7.5}%)`;
        image.alt = `Font ${number} actual lettering sample`;
        label.textContent = `Font ${number} preview`;
        note.textContent = number === 2 ? 'Uppercase letters only.' : '';
        note.hidden = number !== 2;
      }
      select.addEventListener('change', update); update();
    });
    if (document.querySelector('.paws-font-sample')) {
      document.querySelectorAll('.paws-font-guide').forEach(guide => guide.hidden = true);
      document.querySelectorAll('.paws-personal-help').forEach(help => {
        if (help.textContent.includes('Use the font chart')) help.hidden = true;
      });
    }
  }
  document.addEventListener('DOMContentLoaded', setup, {once:true});
  if (document.readyState === 'complete') setup();
})();